import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";

export default class VehicleModelAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      name: "",
      loading: false,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const { selectedMake } = this.props.match.params;

    this.pathname = `vehicles/${selectedMake}/models`;
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
      });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, ...data } = this.state;
    let response;
    const { selectedMake } = this.props.match.params;

    if (id) {
      response = await this.engine.updateItem(this.pathname, id, data);
    } else {
      response = await this.engine.saveItem(this.pathname, data);
    }

    if (response && (response.status === 201 || response.status === 200)) {
      this.props.history.push(`/admin/vehicles_models/${selectedMake}`);
    }

    this.setState({ loading: false });
  };

  render() {
    const { loading, isLoading, name, minYear, maxYear } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormRow
                    label={strings.name}
                    name="name"
                    data={name}
                    changeInput={this.changeInput}
                  />
                  <FormRow
                    label={strings.minimumyear}
                    name="minYear"
                    data={minYear}
                    changeInput={this.changeInput}
                    type="number"
                  />
                  <FormRow
                    label={strings.maxyear}
                    name="maxYear"
                    data={maxYear}
                    changeInput={this.changeInput}
                    type="number"
                    required={false}
                  />
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
